import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

import { ANIMATIONS } from './animations.data';

/**
 * Animates :enter and :leave
 *
 * @example
 * [@fadeInFadeOutAnimation]
 *
 */
export const fadeInFadeOutAnimation: AnimationTriggerMetadata = trigger(
    'fadeInFadeOutAnimation', [
        transition(':enter', [
            // styles at start of transition
            style({ opacity: 0 }),
            // animation and styles at end of transition
            animate(ANIMATIONS.speed.default, style({ opacity: 1 }))
        ])
]);
